import { Button } from "@mui/material";
import React from "react";

const InventoryButton = ({ btnText, btnFunction, type , loading}) => {
  return (
    <Button
      type={type}
      sx={{
        color: "white",
        backgroundColor: btnText === "Reset Filters" ? "#F4A100 !important" : "#0160F1 !important",
        paddingLeft: "2rem",
        paddingRight: "2rem",
        padding: "0.475rem 1rem",
        fontSize: "0.775rem",
        borderRadius: "0.35rem",

        "&:hover": {
          backgroundColor: btnText === "Reset Filters" ? "#D19900 !important " : "darkblue !important",
        },
      }}
      onClick={() => btnFunction()}
      disabled={loading}
    >
      {loading ? 'Saving...' : btnText}
    </Button>
  );
};

export default InventoryButton;
